import { render, staticRenderFns } from "./Handicapper.vue?vue&type=template&id=a07db178"
import script from "./Handicapper.vue?vue&type=script&lang=ts"
export * from "./Handicapper.vue?vue&type=script&lang=ts"
import style0 from "./Handicapper.vue?vue&type=style&index=0&id=a07db178&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports